export default __webpack_public_path__ + "static/media/copy.2f36f99e.svg";